/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Modal, 
    Text, 
    Flex, 
    Button,
    Image,
    TextInput
} from '@mantine/core';

import { useStore } from '../../hooks/use-store';
import { observer } from 'mobx-react';
import { NOTIFICATION_SERVICE } from '../../components/notifications/NotificationService';
import image from './image-upgrade.jpg'
import { useState } from 'react';
export const Element = (props: {
    opened: boolean
    close: () => void
}) => {

    const {
        dataStore: { appStore },
    } = useStore();

    const [credits, setCredits] = useState('400')
    const [boosted, setBoosted] = useState(true)
    // const checks = spaceStore.checkBeforePublish()
    return (
        <Modal
            opened={props.opened} styles={{
                // body: {
                //     background: '#000000'
                // },
                // root: {
                //     background: '#000000 !important'
                // },
            }} onClose={props.close} title={' '} size={'xl'} padding={20}>
            <Flex
                gap={32}
                m={12}
            >
                <div style={{ width: '60%' }}>
                    <Image bg={'#000000'} src={image} w={'100%'} style={{ borderRadius: '10px' }}></Image>
                </div>
                <div style={{ width: '40%' }}>
                    <Flex direction={'column'} gap={2}>
                        <Text color="white" fz={16}>Buy credits</Text>
                        <Text fz={12}>You can use generated images for any purposes, personal or commercial</Text>
                        <Flex bg={'#242424'} w={'100%'} style={{ borderRadius: '4px' }} p={12} mt={6} mb={6} direction={'column'} gap={8}>
                            <Text color="white" fz={16}>Number of credits</Text>
                            <Text fz={12}>Generation/Upscale/Relight: each cost 1 credit</Text>
                            <Text fz={12}>Model train: each cost 60 credits</Text>
                            <TextInput
                                w="100%"

                                size="sm"
                                type={'number'}

                                value={credits}
                                placeholder="100"
                                onChange={(e) => {
                                    setCredits(e.currentTarget.value)
                                }}
                            />
                        </Flex>
                        {/* <Flex bg={'#242424'} w={'100%'} style={{ borderRadius: '4px' }} p={12} mt={6} mb={6} direction={'column'} gap={8}>
                            <Text color="white" fz={16}>Speed Option</Text>
                            <Text fz={12}>Boosted option gives you 4x faster generation speed instead of regular 60-80 seconds</Text>
                            <Button
                                size="xs"
                                style={{
                                    border: '1px solid rgba(255, 255, 255, 1)',
                                    color: 'rgba(255, 255, 255, 1)',
                                    background: boosted ? '#84cc15' : 'transparent',
                                    fontSize: '14px',
                                }}
                                color="rgba(255, 255, 255, 1)"
                                variant={boosted ? "default" : 'outline'}
                                onClick={() => {
                                    setBoosted(true)
                                }}
                            >Boosted</Button>
                            <Button
                                size="xs"
                                style={{
                                    border: '1px solid rgba(255, 255, 255, 1)',
                                    color: 'rgba(255, 255, 255, 1)',
                                    background: !boosted ? '#84cc15' : 'transparent',
                                    fontSize: '14px',
                                }}
                                color="rgba(255, 255, 255, 1)"
                                variant={!boosted ? "default" : 'outline'}
                                onClick={() => {
                                    setBoosted(false)
                                }}
                            >Regular</Button>
                        </Flex> */}
                        <Flex justify={'space-between'}>
                            <Text fz={16}>Subtotal:</Text>
                            <Text color="white" fz={16}>€{`${ (+credits * 0.1).toFixed(2)}`}</Text>
                        </Flex>
                        <Button
                            mt={20}
                            fullWidth={true}
                            loading={false}
                            styles={{
                                root: {
                                    color: 'background: rgba(230, 230, 230, 1)',
                                    height: '42px',
                                    fontSize: '16px',
                                    background: '#84cc15',
                                    border: 'none',
                                    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.25), 0px 0.5px 0px 0px rgba(255, 255, 255, 0.15) inset',
                                }
                            }}
                            variant="default"
                            onClick={async () => {
                                const res = await appStore.getCheckoutLink({ 
                                    credits: +credits,
                                    boosted
                                 })

                                console.log(res)
                                if (res.url) {

                                    let a = document.createElement('a');
                                    a.target = '_blank';
                                    a.href = res.url;
                                    a.click();
                                    props.close()
                                } else {
                                    NOTIFICATION_SERVICE.errorNotification('Something went wrong')
                                }
                            }}
                        >
                            Buy
                        </Button>
                    </Flex>
                </div>

            </Flex>

            {/* {
                checks.length > 0 ? (
                    <Paper shadow="xs" pos={'relative'} bg={'rgba(230, 120, 54, 0.15)'} pt={12} pb={12} pl={48} pr={32}>
                        <div style={{ position: 'absolute', top: '14px', left: '17px' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.5067 10.6133L10.24 2.93334C9.66665 1.9 8.87332 1.33334 7.99998 1.33334C7.12665 1.33334 6.33332 1.9 5.75998 2.93334L1.49332 10.6133C0.953318 11.5933 0.893318 12.5333 1.32665 13.2733C1.75999 14.0133 2.61332 14.42 3.73332 14.42H12.2667C13.3867 14.42 14.24 14.0133 14.6733 13.2733C15.1067 12.5333 15.0467 11.5867 14.5067 10.6133ZM7.49998 6C7.49998 5.72667 7.72665 5.5 7.99998 5.5C8.27332 5.5 8.49998 5.72667 8.49998 6V9.33334C8.49998 9.60667 8.27332 9.83334 7.99998 9.83334C7.72665 9.83334 7.49998 9.60667 7.49998 9.33334V6ZM8.47332 11.8067C8.43998 11.8333 8.40665 11.86 8.37332 11.8867C8.33332 11.9133 8.29332 11.9333 8.25332 11.9467C8.21332 11.9667 8.17332 11.98 8.12665 11.9867C8.08665 11.9933 8.03998 12 7.99998 12C7.95998 12 7.91332 11.9933 7.86665 11.9867C7.82665 11.98 7.78665 11.9667 7.74665 11.9467C7.70665 11.9333 7.66665 11.9133 7.62665 11.8867C7.59332 11.86 7.55998 11.8333 7.52665 11.8067C7.40665 11.68 7.33332 11.5067 7.33332 11.3333C7.33332 11.16 7.40665 10.9867 7.52665 10.86C7.55998 10.8333 7.59332 10.8067 7.62665 10.78C7.66665 10.7533 7.70665 10.7333 7.74665 10.72C7.78665 10.7 7.82665 10.6867 7.86665 10.68C7.95332 10.66 8.04665 10.66 8.12665 10.68C8.17332 10.6867 8.21332 10.7 8.25332 10.72C8.29332 10.7333 8.33332 10.7533 8.37332 10.78C8.40665 10.8067 8.43998 10.8333 8.47332 10.86C8.59332 10.9867 8.66665 11.16 8.66665 11.3333C8.66665 11.5067 8.59332 11.68 8.47332 11.8067Z" fill="#E67836" />
                            </svg>

                        </div>
                        <Text fw={'bold'} size={14} color='white'>
                            {t("pro.disabled.features")}
                        </Text>
                        <Text mt={6} size={14} color='white'>
                            {t("pro.disabled.features.preview")}

                        </Text>
                        <Text mt={6} size={14} color='white'>
                            {t("pro.disabled.used.features")}
                        </Text>
                        {
                            checks.map((item) => (
                                <Flex ml={12} align={'center'} gap={8} mt={2} >
                                    <Text size={14} color='white'>
                                        - {item}
                                    </Text>
                                    <ProBadge />
                                </Flex>
                            ))
                        }


                    </Paper>
                ) : null
            } */}
        </Modal >
    )
}

export const BillingModal = observer(Element);